module.exports = __webpack_public_path__ + "img/zzjgt.d75bde71.png";